<template>

  <div class="app">
    <Header></Header>
    <div class="conversion">

      <section class="section-template">
        <div class="banner">
          <div class="content">
            <div class="title">一键生成H5页面+短链接+二维码</div>
            <div class="subtitle">短链接、二维码行业解决方案，支持数据统计等</div>
            <button onclick="window.location='/tabs/webPage'">立即使用</button>
          </div>
        </div>
        <div class="ad">
          <div class="title">h5页面创作三大优势</div>
          <div class="list">
            <li>
              <div class="content d-flex justify-content-between align-items-center">
                <div class="text">
                  <div class="tit">制作简单，一键生成</div>
                  <div class="subtit">H5页面制作更简单，自由图文排版，所见即所得<br>
                    可灵活组合图文标题，音视频、文件等<br>
                    一键生成二维码和短链接，推广使用更便捷</div>
                </div>
                <img src="../assets/images/page/template-ad-1.png" alt="四五推H5模板">
              </div>
            </li>
            <li>
              <div class="content d-flex justify-content-between align-items-center">
                <img src="../assets/images/page/template-ad-2.png" alt="四五推H5模板">
                <div class="text">
                  <div class="tit">功能强大，数据统计,可修改</div>
                  <div class="subtit">随时修改页面内容，富文本编辑更方便<br>
                    灵活添加表单标签，收集客户信息更直接<br>
                    支持数据统计功能，可实时统计推广效果</div>
                </div>
              </div>
            </li>
            <li>
              <div class="content d-flex justify-content-between align-items-center">
                <div class="text">
                  <div class="tit">微信PC，多端应用，使用便捷</div>
                  <div class="subtit">支持微信小程序，可随时随地查看数据<br>
                    支持PC端查看更详细信息，对数据留档</div>
                </div>
                <img src="../assets/images/page/template-ad-3.png" alt="四五推H5模板">
              </div>
            </li>
          </div>
        </div>
        <div class="introduce">
          <div class="title">专业可靠的营销工具</div>
          <div class="content d-flex justify-content-between align-items-center">
            <li>
              <img src="../assets/images/page/template-introduce-list-1.png" alt="四五推H5模板">
              <p>海量h5页面创作</p>
              <span>模板类型多样化，适合不同行业</span>
            </li>
            <li>
              <img src="../assets/images/page/template-introduce-list-2.png" alt="四五推H5模板">
              <p>一键分享</p>
              <span>每个人都能随时查看营销推广
                        页面</span>
            </li>
            <li>
              <img src="../assets/images/page/template-introduce-list-3.png" alt="四五推H5模板">
              <p>专属小程序</p>
              <span>小程序拉起页面，传播更便捷</span>
            </li>
            <li>
              <img src="../assets/images/page/template-introduce-list-4.png" alt="四五推H5模板">
              <p>数据API对接</p>
              <span>将表单数据与你已有的系统对接</span>
            </li>
            <li>
              <img src="../assets/images/page/template-introduce-list-5.png" alt="四五推H5模板">
              <p>表单数据可信存证</p>
              <span>信息收集方便快捷，对接方便</span>
            </li>
          </div>
        </div>
      </section>
      <section class="section-shortTool">
        <div class="khpj" style="padding:70px 0">
          <div class="title">客户评价</div>
          <ul class="d-flex justify-content-between align-items-center" style="margin-top: 45px;">
            <li>
              <div class="tit d-flex justify-content-between align-items-center">
                <p>新东方</p>
                <img src="../assets/images/page/xdf_log.jpg">
              </div>
              <div class="container">
                <span></span>
                <p>通过四五推h5页面创作的使用，通过二维码一键分享，极大提高了我们的工作效率；专属小程序拉起页面，使得我们能实时对接API表单数据，方便招生留资。</p>
                <span></span>
              </div>
            </li>
            <li>
              <div class="tit d-flex justify-content-between align-items-center">
                <p>芒果TV</p>
                <img src="../assets/images/page/khpj4.jpg">
              </div>
              <div class="container">
                <span></span>
                <p>
                  四五推模板类型多样化，满足了我们业务需求，微信端也可随时随地查看数据，数据留档更便捷。
                </p>
                <span></span>
              </div>
            </li>
            <li>
              <div class="tit d-flex justify-content-between align-items-center">
                <p>欧普照明</p>
                <img src="../assets/images/page/opzm_logo.jpg">
              </div>
              <div class="container">
                <span></span>
                <p>我们的工作人员，都可以随时修改页面内容，也可以多人编辑，四五推h5页面创作完美的解决了我们的需求；数据统计功能和实时推广效果统计很实用。</p>
                <span></span>
              </div>
            </li>
          </ul>
        </div>
        <div class="zmyh" style="padding: 70px 0 68px;">
          <div class="title">知名客户</div>
          <img src="../assets/images/page/zmyh-logo3.png">
        </div>
      </section>






    </div>



    <Foot ref="foot" ></Foot>

  </div>
</template>

<script>
  import Header from "./header";
  import Foot from "./foot";
  export default {
    name: "Home_tb",
    components: { Header:Header,Foot:Foot},
    data() {
      return {
        url:"",
        isVip: false,
        isGuest: true,
        user_info: {}
      }
    },
    mounted() {
      const token = this.$storeLocal.get('token');
      const user_info = this.$storeLocal.get('userInfo');
      const times = Date.parse(new Date())/1000;

      if (token !== null && token !== '' && token !== undefined) {
        if (user_info.expire_date > times){
          this.isVip = true;
        }
        this.isGuest = false;
        this.user_info = user_info;
      }

    },
    methods: {
      async zh() {
        const url = this.url;
        this.$router.push('/tabs/weiboIndex');
      },
      async play_video(type){
        var video_url='';
        if(type==1) {
          video_url='https://img-browser.ttdwz.cc/video/SVID_20201207_213823_1.mp4';
        }else if(type==2) {
          video_url='https://img-browser.ttdwz.cc/video/SVID_20201207_215535_1.mp4';
        }else if(type==3) {
          video_url='https://img-browser.ttdwz.cc/video/SVID_20201207_215535_1.mp4';
        }
        $('.player'+type+'_box').html('<video id="player1" controls autoplay  style="width:172px;height: 380px;">\n' +
                '  　　<source src="'+video_url+'" type="video/mp4"></video>');


      }
    }

  }
</script>

<style>
  .app{
    background-color: #ffffff;
  }
  .gold {
    color: #FFD700;
  }

  a {
    text-decoration: none;
    cursor: pointer;
    color: #ffffff;
  }

  button {
    cursor: pointer;
  }

  .blue-btn {
    background-color: #008DF2;
  }

  .green-btn {
    background-color: #07CC00;
  }

  .gray-back {
    background-color: #F5F5F5!important;
  }

  .pl-10 {
    padding-left: 10%;
  }


  .contactusdiyou .hoverbtn {
    width: 30px;
    height: 129px;
    padding-top: 20px;
    cursor: pointer;
    position: absolute;
    top: 50%;
    margin-top: -66px;
    left: -30px;
    font-size: 14px;
    color: #fff;
    background: #008df2;
    -webkit-border-radius: 3px 0px 0px 3px;
    -moz-border-radius: 3px 0px 0px 3px;
    -o-border-radius: 3px 0px 0px 3px;
    border-radius: 3px 0px 0px 3px;
    -moz-box-shadow: -4px 4px 4px -4px #000;
    -webkit-box-shadow: -4px 4px 4px -4px #000;
    box-shadow: -4px 4px 4px -4px #000;
  }

  .contactusdiyou .hoverbtn span {
    width: 30px;
    height: 19px;
    line-height: 19px;
    text-align: center;
    overflow: hidden;
    float: left;
  }

  .contactusdiyou .hoverbtn .hoverimg {
    width: 13px;
    height: 9px;
    margin: 10px 0 0 10px;
    float: left;
    display: inline;
    background-repeat: no-repeat;
  }

  .hoverimg2 {
    background: url(../assets/images/index/hoverbtnbg1.gif) no-repeat;
  }

  .contactusdiyou .conter {
    width: 186px;
    height: 560px;
    margin-left: 22px;
    position: absolute;
    top: 55%;
    *margin-top: -140px;
    margin-top: -280px;
  }

  .contactusdiyou .conter .con1 {
    border-bottom: 1px solid #6a6a6a;
    padding-bottom: 22px;
  }

  .contactusdiyou .conter .con1 dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }

  .contactusdiyou dl .f1 {
    width: 142px;
    height: 36px;
    line-height: 36px;
    float: right;
    font-size: 14px;
    _font-size: 14px;
    *font-size: 15px;
    color: #fff;
    vertical-align: top;
    font-weight: bold;
  }

  .contactusdiyou dl .f2 {
    width: 142px;
    float: right;
    font-size: 12px;
    color: #fff;
    height: 30px;
    line-height: 30px;
  }

  .kefuQQ a {
    background: url(../assets/images/index/button-custom-qq.gif) no-repeat;
    width: 70px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }

  .kefuQQ a:hover {
    background: url(../assets/images/index/button-custom-qq-h.gif) no-repeat;
  }
  .contactusdiyou .conter .con1 dl dd .ph_num {
    font: 18px 'Microsoft yahei';
    *font-size: 16px;
    _font-size: 16px;
    color: #fff;
    height: 25px;
  }

  .contactusdiyou .qqcall {
    padding: 22px 0;
    border-bottom: 1px solid #6a6a6a;
  }

  .contactusdiyou .qqcall dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }

  .contactusdiyou .weixincall {
    float: right;
    padding: 22px 0;
    border-bottom: 1px solid #6a6a6a;
  }

  .contactusdiyou .weixincall dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }

  .contactusdiyou .weixincall .f3 {
    float: right;
    width: 73px;
    height: auto;
    margin-right: 69px;
    display: inline;
  }

  .contactusdiyou .weixincall .f3 img {
    width: 150px;
    height: auto;
  }

  .contactusdiyou .dytimer {
    float: right;
    width: 160px;
    height: 40px;
    padding: 16px 0 15px 0; /* background: #007b77; */
    margin: 20px 0 0 0;
  }

  .contactusdiyou .dytimer span {
    display: block;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #fff;
  }
  /*用户协议*/
  .userProtocol {
  }

  .userProtocol .bg-color {
    background-color: white;
    width: 1200px;
    height: 60px;
    text-align: center;
  }

  .userProtocol .bg-color a {
    color: black;
    font-size: 20px;
    line-height: 60px;
  }

  .userProtocol .box-center {
    width: 1200px;
    margin: 0 auto;
  }

  .userProtocol .box {
    width: 100%;
  }

  .userProtocol .word_area {
    padding: 24px;
    margin-bottom: 30px;
    background-color: #F5F5F5;
    color: #555;
    overflow: hidden;
  }

  .userProtocol .box .copyright {
    width: 1200px;
    height: 140px;
    padding-top: 40px;
    text-align: center;
    margin: 0 auto;
    color: #666666;
  }

  .userProtocol .box .copyright div {
    width: 100%;
    height: 14px;
    font-size: 14px;
    margin-bottom: 25px;
  }


  .userProtocol .box .copyright div span a {
    color: #666666;
  }

  .userProtocol h3, h1 {
    font-size: 16px;
    margin-bottom: 25px;
  }

  .userProtocol h1 {
    font-size: 25px;
    text-align: center;
    margin-bottom: 25px;
  }

  .userProtocol ol {
    margin-bottom: 20px;
    text-indent: 2em;
    line-height: 25px
  }


  /*问题*/
  .problem .bg-color {
    background-color: white;
    width: 100%;
    height: 60px;
    padding-left: 25%
  }

  .problem .bg-color a {
    color: black;
    font-size: 20px;
    line-height: 60px;
  }

  .problem .new-style .font-style {
    line-height: 50px
  }

  .problem .problem-style {
    width: 1180px;
    height: 900px;
    border: 1px solid #e6e6e6;
    overflow-y: auto;
    margin-top: 20px;
  }

  .problem .problem-style .problem-title {
    text-align: center;
    font-size: 30px;
    margin: 30px 0
  }

  .problem .problem-style .problem-small {
    font-size: 20px;
    margin: 15px 15px;
  }

  .problem .problem-style .problem-text {
    font-size: 16px;
    text-indent: 2em;
    margin: 15px 15px;
  }

  .problem .problem-style li {
    font-size: 16px;
    line-height: 30px
  }

  .problem .problem-style .problem-img {
    text-align: center;
    height: 1000px;
    width: 1200px
  }

  .problem .problem-style .problem-img img {
    height: 800px;
    width: 90%
  }

  /*浮动导航*/
  .float-nav-box {
    width: 80px;
    height: auto;
    background-color: #008DF2;
    color: #FFFFFF;
    position: fixed;
    top: 50%;
    right: 0;
    margin-top: -230px;
    padding: 0 10px;
  }

  .float-nav-box .div-box {
    width: 100%;
    height: 70px;
    text-align: center;
    padding-top: 22px;
    cursor: pointer;
  }

  .float-nav-box .div-box i {
    font-size: 30px;
  }

  .float-nav-box .div-box .qrcode-box {
    width: 160px;
    height: 190px;
    background-color: #FFFFFF;
    box-shadow: 0 0 10px #D9D9D9;
    border-radius: 8px;
    display: none;
  }

  .float-nav-box .div-box:hover .qrcode-box{
    display: block;
  }

  .float-nav-box .div-box .app-qrcode {
    position: absolute;
    top: 0;
    left: -190px;
  }

  .float-nav-box .div-box .gzh-qrcode {
    position: absolute;
    top: 100px;
    left: -190px;
  }

  .float-nav-box .div-box .kf-qrcode {
    position: absolute;
    top: 190px;
    left: -190px;
  }

  .float-nav-box .div-box .sw-qrcode {
    position: absolute;
    top: 280px;
    left: -190px;
  }

  .float-nav-box .div-box .qrcode-box .img-box {
    width: 140px;
    height: 170px;
    z-index: 99;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #FFFFFF;
    border-radius: 8px;
    padding: 10px;
  }

  .float-nav-box .div-box .qrcode-box .img-box img {
    width: 140px;
    height: 140px;
  }

  .float-nav-box .div-box .qrcode-box .img-box div {
    width: 140px;
    height: 20px;
    font-size: 16px;
    text-align: center;
    line-height: 20px;
    color: #333333;
    margin-top: 5px;
  }

  .float-nav-box .div-box .qrcode-box span {
    display: block;
    position: absolute;
    top: 30px;
    right: -10px;
    width: 20px;
    height: 20px;
    box-shadow: 0 0 10px #D9D9D9;
    background-color: #ffffff;
    transform: rotate(45deg);
    z-index: 88;
  }

  .line-bottom {
    border-bottom: 1px solid #FFFFFF;
  }

  /*api文档*/
  .user-console .u-rig {
    width: 1200px;
    min-height: 780px;
    margin: 0 auto;
  }

  .user-console h2.title {
    border-left: 4px solid #008bff;
    height: 20px;
    line-height: 20px;
    padding-left: 5px;
    margin: 10px 0 20px 0;
    font-size: 22px;
    font-weight: 500;
  }

  .icon-blue{
    color: #008df2;
  }

  .section-template .banner {
    width: 100%;
    height: 380px;
    background: url(../assets/images/page/template-banner.jpg);
    background-repeat: no-repeat;
    background-size: auto 380px;
    background-position: center center;
  }

  .section-template .banner .content {
    width: 1180px;
    margin: 0 auto;
    padding-top: 110px;
  }

  .section-template .banner .content .title {
    font-size: 38px;
    font-weight: 500;
    color: #1D2843;
  }

  .section-template .banner .content .subtitle {
    font-size: 16px;
    color: #1D2843;
    margin-top: 16px;
  }

  .section-template .banner .content button {
    width: 160px;
    height: 40px;
    background: #2E6BFC;
    border-radius: 4px;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 53px;
  }

  .section-template .ad {
    padding-top: 70px;
  }

  .section-template .ad .title {
    font-size: 30px;
    color: #1D2843;
    text-align: center;
  }

  .section-template .ad .list li .content {
    width: 1180px;
    margin: 0 auto;
    height: 380px;
    padding: 0 80px 0 140px;
  }

  .section-template .ad .list li {
    width: 100%;
    height: 380px;
    background: #fff;
    opacity: 1;
  }

  .section-template .ad .list li:nth-of-type(2) {
    background: #EFF7FD;

  }

  /* .section-template .ad .list li:nth-of-type(2) .content{
      padding: 0 140px 0 140px;

  } */
  .section-template .ad .list li:nth-of-type(2) .content img {
    height: 220px;
  }

  .section-template .ad .list li img {
    height: 300px;
  }

  .section-template .ad .list li .text .tit {
    font-size: 26px;
    font-weight: 600;
    color: #3A3E44;
  }

  .section-template .ad .list li .text .subtit {
    font-size: 16px;
    color: #1D2843;
    margin-top: 40px;
    line-height: 23px;
  }

  .section-template .introduce {
    width: 100%;
    height: 604px;
    background: #FFFFFF;
    background: url(../assets/images/page/template-introduce-bg.jpg);
    background-repeat: no-repeat;
    background-size: auto 604px;
    background-position: center center;
    padding: 70px 81px;
  }

  .section-template .introduce .title {
    font-size: 30px;
    color: #1D2843;
    text-align: center;

  }

  .section-template .introduce .content {
    width: 1180px;
    margin: 60px auto 0;
  }

  .section-template .introduce .content li {
    width: 228px;
    height: 350px;
    box-shadow: 0px 6px 15px rgba(27, 77, 203, 0.08);
    background: url(../assets/images/page/template-introduce-list.png);
    background-repeat: no-repeat;
    background-size: 228px auto;
    background-position: center center;
    padding: 50px 0 0;
    position: relative;
  }

  .section-template .introduce .content li img {
    width: 172px;
    display: block;
    margin: 0 auto;
  }

  .section-template .introduce .content li p {
    font-size: 20px;
    font-weight: 600;
    color: #1D2843;
    text-align: center;
    position: absolute;
    width: 100%;
    bottom: 101px;
  }

  .section-template .introduce .content li span {
    font-size: 14px;
    color: #1D2843;
    display: block;
    width: 186px;
    position: absolute;
    top: 269px;
    left: 50%;
    transform: translateX(-50%);
  }
  .section-template *, .section-shortTool * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .align-items-center {
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .justify-content-between {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between
  }
  .position-relative {
    position: relative;
  }

  .position-absolute {
    position: absolute;
  }

  .d-flex {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }



  .section-shortTool .zzfu ul{
    width: 1180px;
    margin: 40px auto 0;
  }
  .section-shortTool .zzfu ul li p{
    font-size: 18px;
    font-weight: 500;
    color: #1D2843;
  }
  .section-shortTool .zzfu ul li img{
    width: 126px;
    display: block;
    margin: 0 auto 23px;
  }
  .section-shortTool .khpj{
    background: #F7F8FB;
    padding: 81px 0 88px;
  }
  .section-shortTool .khpj .title{
    font-size: 30px;
    font-weight: 500;
    color: #1D2843;
    text-align: center;
  }
  .section-shortTool .khpj ul{
    width: 1180px;
    margin: 55px auto 0;
  }
  .section-shortTool .khpj ul li{
    width: 340px;
    height: 327px;
    background: #FFFFFF;
    box-shadow: 0px 6px 15px 0px rgba(27, 77, 203, 0.08);
    padding: 33px 41px;
  }
  .section-shortTool .khpj ul li .container{
    margin-top: 10px;
  }
  .section-shortTool .khpj ul li .container p{
    font-size: 14px;
    color: #1D2843;
    margin-top: 13px;
    line-height: 28px;
  }
  .section-shortTool .khpj ul li .container span:nth-of-type(1){
    background: url(../assets/images/page/quotation-mark1.png);
    width: 18px;
    height: 14px;
    display: block;
    background-position: center center;
    background-size: 18px auto;
    background-repeat: no-repeat;
  }
  .section-shortTool .khpj ul li .container span:nth-of-type(2){
    background: url(../assets/images/page/quotation-mark2.png);
    float: right;
    width: 18px;
    height: 14px;
    display: block;
    background-position: center center;
    background-size: 18px auto;
    background-repeat: no-repeat;
  }
  .section-shortTool .khpj ul li .tit{
    padding-bottom: 14px;
    border-bottom: 1px solid #EDEEF6;
  }
  .section-shortTool .khpj ul li .tit p{
    font-size: 18px;
    font-weight: 500;
    color: #1E2844;
  }
  .section-shortTool .khpj ul li .tit img{
    width: 130px;
  }
  .section-shortTool .zmyh{
    width: 100%;
    background: linear-gradient(90deg, #FEFFFF 0%, #EBF3FF 100%);
    padding: 86px 0 92px;
  }
  .section-shortTool .zmyh .title{
    font-size: 30px;
    font-weight: 500;
    color: #1D2843;
    text-align: center;
  }
  .section-shortTool .zmyh img{
    display: block;
    margin: 34px auto 0;
    width: 1180px;
  }
  .section-shortTool .tryout{
    width: 100%;
    padding: 77px 0 57px;
    background-size: 1920px auto;
  }
  .section-shortTool .tryout .title{
    font-size: 30px;
    font-weight: 500;
    color: #1D2843;
    text-align: center;
  }

</style>
